import { clone, IProperty, ISettingsState } from '../../helpers/';
import { DEFAULT_JOURNEY_ID } from '../../constants';
import types from '../types';

const initialState: ISettingsState = {
	isOpen : false
};

const settingsReducer = function(state = initialState, action) {
	let stateClone: ISettingsState = clone(state);

	switch(action.type) {

		case types.TOGGLE_SETTINGS_SIDEBAR: 
			stateClone.isOpen = !stateClone.isOpen;
			break;
	}

	return stateClone;
};

export default settingsReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/settings.ts